import { createAction } from "redux-starter-kit";

import {
  UNFREEZE_FAILURE,
  UNFREEZE_REQUEST,
  UNFREEZE_SUCCESS
} from "../types";
import fetchFactoringProfile from "./fetchFactoringProfile";
import fetchFreezeEvents from "./fetchFreezeEvents";

const unfreezeReceivables = (factoringId, reason) => async (
  dispatch,
  getState,
  { api }
) => {
  try {
    dispatch(createAction(UNFREEZE_REQUEST)());
    const response = await api.factoring.unfreezeFactoring(factoringId, reason);
    dispatch(createAction(UNFREEZE_SUCCESS)({ factoringId, response }));
    // Fire-and-forget: don't block the calling modal on the refetches.
    dispatch(fetchFactoringProfile(factoringId));
    dispatch(fetchFreezeEvents(factoringId));
    return response;
  } catch (err) {
    dispatch(createAction(UNFREEZE_FAILURE)(err));
    throw err;
  }
};

export default unfreezeReceivables;
